export class Cookies {
    static _name = 'Cookies';
    static _instance = new Cookies();
    constructor() {
        if (Cookies._instance) {
            throw new Error(Cookies._name + ' is a Singleton and can only be accessed through ' + Cookies._name + '.getInstance()');
        }
        Cookies._instance = this;
    }
    static getInstance() {
        return Cookies._instance;
    }
    docCookie = () => {
        const out = Object.fromEntries(document.cookie.split(/; */).map((cookie) => {
            const [key, value] = cookie.split(/=(.*)$/, 2);
            return [key, decodeURIComponent(value)];
        }));
        Object.keys(out).forEach((key) => {
            if (key === '')
                delete out[key];
        });
        return out;
    };
    getItem = (sKey) => {
        if (!sKey) {
            return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
    };
    setItem = (sKey, sValue, vEnd, sPath, sDomain, bSecure) => {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        let sExpires = '';
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                    break;
                case String:
                    sExpires = '; expires=' + vEnd;
                    break;
                case Date:
                    sExpires = '; expires=' + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
        return true;
    };
    removeItem = (sKey, sPath, sDomain) => {
        if (!this.hasItem(sKey)) {
            return false;
        }
        document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
        return true;
    };
    hasItem = (sKey) => {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
    };
    keys = () => {
        const aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
        for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    };
    clear = (sPath, sDomain) => {
        const aKeys = this.keys();
        for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
            this.removeItem(aKeys[nIdx], sPath, sDomain);
        }
    };
}
